/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Colors } from '../../../constants';
import ButtonCopy from './ButtonCopy';
import useWindowDimensions from '../../../custom_hooks/useWindowDimensions';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { useRef, useContext } from 'react';
import { ModalContext } from "../../../contexts/modalContext";

export default function Preview ({
  onClickBack,
  title,
  timezone,
  shareTimings,
  location,
  timeInterval,
  isoTime,
  meetingId,
  meetingLinkPath
 }) {

  const WEEKDAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MONTHNAMES = ["January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"];
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const elementRef = useRef();
  let { handleModal, hideModal } = useContext(ModalContext);

  const copyToClipboard = (e) => {
    e.target.blur();
    copyCodeToClipboard();
  }

  const back = () => {
    onClickBack();
  }

  let dates = [];
  let keys = Object.keys(shareTimings);
  keys = keys.sort(function(a,b) {
    var aComps = a.split("-");
    var bComps = b.split("-");
    var aDate = new Date(aComps[2], aComps[1], aComps[0]);
    var bDate = new Date(bComps[2], bComps[1], bComps[0]);
    return aDate.getTime() - bDate.getTime();
  });
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i].split('-').reverse();
    let date = new Date(key);
    dates.push(
      <div 
        key ={keys[i]}
        style={{
          fontWeight: 600,
          color: `#${Colors.black}`,
          marginTop: '10px'
        }}
      >
        <div style={{ display: 'block' }}>
          { t(WEEKDAY[date.getDay()]) }, { date.getDate() } { t(MONTHNAMES[date.getMonth()]) } {date.getFullYear()}
        </div>

        <div
          style={{
            display: 'inline-block',
            fontWeight: 'normal',
            marginTop: '10px',
            color: `#${Colors.black}`,
          }}
        >
          <Timings isoTime={isoTime} data={shareTimings[keys[i]]} timezoneName={timezone} meetingId={meetingId} meetingLinkPath={meetingLinkPath} />
        </div>
      </div>
    );
  };



  const copyCodeToClipboard = () => {
    const el = elementRef;
    let element = el.current;
    let str = element.innerHTML;

    function listener(e) {
      e.clipboardData.setData("text/html", str);
      e.clipboardData.setData("text/plain", str);
      e.preventDefault();
      handleModal('',
                  "Successfully copied! Paste schedule options to email body.",
                  hideModal,
                  { submit: "Close" },
                  true,
                  "#0033CC",
                  true );
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);

  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 16px;
        overflow: hidden auto;
        font-family: 'Poppins', sans-serif;

        @media(max-width: 858px) {
          overflow: unset;
          max-height: calc(100vh - 13rem);
        }
      `}
    >
      <div
        css={css`
          width: 100%;
        `}
      >
        <div
          css={css`
            display: flex;

            @media(max-width: 295px) {
              flex-direction: column;
              justify-content: flex-start;
            }
          `}
        >
          <div
            css={css`
              flex: 1;
              font-weight: 600;
              color: #${Colors.black}
            `}
          >
            Email Preview
          </div>

          <div
            css={css`
              flex: 1;
              font-weight: 600;
              color: #${Colors.primaryColor};
              display: flex;
              justify-content: flex-end;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }

              @media(max-width: 295px) {
                margin: 8px 0;
                justify-content: flex-start;
              }
            `}
            onClick={() => back()}
          >
            Choose new times
          </div>
        </div>

      </div>

      <div
        style={{
          display: 'block',
          width: '100%',
          marginTop: '16px',
          height: width > 858 ? '100%' : 'calc(100vh - 5rem)',
          overflow:  width > 858 ? 'hidden auto' : 'unset'
        }}
        id={'preview-email-content'}
        ref={elementRef}
      >
        <span style={{
          fontSize: '16px',
          fontWeight: 600,
          color: `#${Colors.black}`,
          display: 'block',
          marginTop: '5px'
        }}>
          { title }
        </span>
        <span style={{
          fontSize: '14px',
          color: `#${Colors.black}`,
          display: 'block',
          marginTop: '5px',
          fontWeight: 'normal'
        }}>
          Location: { location }
        </span>
        <span style={{
          fontSize: '14px',
          color: `#${Colors.black}`,
          display: 'block',
          marginTop: '5px',
          fontWeight: 'normal'
        }}>
          Duration: { `${timeInterval} mins` }
        </span>
        <span style={{
          fontSize: '14px',
          color: `#${Colors.black}`,
          display: 'block',
          marginTop: '5px',
          fontWeight: 'normal'
        }}>
          <span>Time zone: </span>{ timezone }
        </span>

        <br />
        <br />
        <div
          style={{
            overflow: 'hidden auto',
            maxHeight: width > 858 ? 'calc(100vh - 18.5rem)' : 'calc(100vh - 20rem)',
            width: '100%'
          }}
        >
          { dates }
          
        </div>

      </div>
      
      <br /><br />

      { width > 858 && (
        <ButtonCopy
          onClick={copyToClipboard}
          onBackClick={back} />
      )}
    </div>
  );
}

function Timings ({data, isoTime, timezoneName, meetingId, meetingLinkPath}) {
  let timings = [];
  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      timings.push(
        <div 
          key={data[i]}
          style={{
            display: 'inline-block',
            marginRight: '5px',
            marginBottom: '7px',
            border: `1px solid #${Colors.primaryColor}`,
            padding: '7px',
            color: `#${Colors.primaryColor}`
          }}
        >
          <a style={{ cursor: 'pointer', textDecoration: 'none' }} href={`${meetingLinkPath}/${meetingId}/?current_time=${data[i]}`} target={'_blank'}>
            {isoTime === true ? (moment(`${data[i]}`,'x').tz(timezoneName).format("HH:mm")) : (moment(`${data[i]}`,'x').tz(timezoneName).format("hh:mm a"))}
          </a>
        </div>
      )
    }
    
  }
  return timings;
}